import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatabaseKeyPage from '../pages/DatabaseKeyPage';
import api from '../api/api';
import { getdatabasekey, getKeyMode } from '../api/configHelper';

export default function InitialPage() {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getUrlDatabaseKey = () => {
      const params = new URLSearchParams(window.location.search);
      for (const [name, value] of params.entries()) {
        if (name.toLowerCase() === "dbkey") {
          return value.trim();
        }
      }
      return "";
    };

    const openLoginForKey = async (key) => {
      sessionStorage.setItem("databaseKey", key);
      const companyData = await api.Companydetails();
      sessionStorage.setItem("companyDetails", JSON.stringify(companyData));
      navigate(`/login${window.location.search}`, { replace: true });
    };

    const loadKeys = async () => {
      try {
        const [databaseKeys, keyMode] = await Promise.all([
          getdatabasekey(),
          getKeyMode()
        ]);
        const availableKeys = Array.isArray(databaseKeys) ? databaseKeys : [];
        setKeys(availableKeys);

        const urlDatabaseKey = getUrlDatabaseKey();
        if (urlDatabaseKey) {
          const configuredKey = availableKeys.find(
            (key) => key.toLowerCase() === urlDatabaseKey.toLowerCase()
          );
          const validUrlKey = keyMode === "custom" ? urlDatabaseKey : configuredKey;

          if (validUrlKey) {
            try {
              await openLoginForKey(validUrlKey);
              return;
            } catch (err) {
              sessionStorage.removeItem("databaseKey");
              sessionStorage.removeItem("companyDetails");
              console.error("Invalid database key from URL:", err);
            }
          }
        }

        if (keyMode === "fixed" && availableKeys.length === 1) {
          // Single key, set it and go to login
          await openLoginForKey(availableKeys[0]);
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to load database keys:", err);
        setLoading(false);
      }
    };
    loadKeys();
  }, [navigate]);

  if (loading) {
    return (
      <div className="relative h-screen w-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loading loading-spinner loading-lg"></div>
          <p className="mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  if (keys.length > 1) {
    return <DatabaseKeyPage />;
  }

  return <DatabaseKeyPage />;
}
